<template>
  <ca-modal
    ref="modal"
    title="O que ainda não atendemos">
    <template slot="body">
      <ca-row>
        <ca-col size="3" class="ca-u-text-center ca-u-margin-top">
          <ca-illustration name="payroll-info" width="120"></ca-illustration>
        </ca-col>
        <ca-col size="9">
          <ca-list theme="check">
            <ca-list-item>
              Não gera o DARF de PIS sobre a base da folha de pagamento para as entidades
              previstas no Art. 13 da  MEDIDA PROVISÓRIA No 2.158-35, DE 24 DE AGOSTO DE 2001;
            </ca-list-item>
          </ca-list>
        </ca-col>
      </ca-row>
    </template>

    <ca-row slot="footer">
      <ca-col offset="9" size="3">
        <ca-button
          theme="primary"
          full-width
          @click="$refs.modal.close()">
          Ok, entendi
        </ca-button>
      </ca-col>
    </ca-row>
  </ca-modal>
</template>

<script>
export default {
  name: 'WorkingOnDetailsModal',
};
</script>
